import { AnnuityItemsViewModel } from "./../../models/annuity-view.model";
import {
  GetCSPSubscription,
  GetCSPSubscriptionActions,
  CSPModifySubscriptionViewModel,
  CSPModifySubscriptionResponse,
} from "./../../models/csp.model";
import { BreadcrumbComponent } from "./../../breadcrumb/breadcrumb.component";
import { ManageService } from "./../../services/manage.service";
import {
  ADKDetailsItemViewModel,
  ADKDetailsViewModel,
} from "./../../models/adk-details-view.model";
import { Component, OnInit, ViewChild, OnDestroy, ElementRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { NgProgress } from "ngx-progressbar";
import { Observable, Subject } from "rxjs";
import { DialogService } from "../../services/dialog.service";
import { CommonService } from "../../services";
import { CustomerPaymentsOutput } from "../../models/account-ledger.model";
import { CheckOutService } from "../../services/checkout.service";
import { switchMap, map, takeUntil } from "rxjs/operators";
import { NgProgressService } from "../../services/ngProgress.service";

declare var jquery: any;
declare var $: any;

@Component({
  selector: "app-manage-adkdetails",
  templateUrl: "./manage-adkdetails.component.html",
  styleUrls: ["./manage-adkdetails.component.css"],
})
export class ManageAdkdetailsComponent implements OnInit, OnDestroy {
  @ViewChild("ParentWrapper", { static: true }) parentWrapper: ElementRef;

  searchField = "";
  searchOrder = "";

  currentStatus = "Status";
  userStatus = "";

  prevPage: string;

  ariaExpanded = false;
  setDisabled = true;
  showCancelContract = true;
  hasPurchaseAccess = false;
  confirmRequired = false;
  loadContent = false;
  finishLoading = true;
  isEndUserLoading = false;
  isSubscriptionLoading = false;
  discardChanges$: Observable<boolean>;

  details: ADKDetailsViewModel;
  adkItems: ADKDetailsItemViewModel;
  subscriptions: GetCSPSubscription[] = [];
  sortedSubscriptions: GetCSPSubscription[] = [];
  actions: GetCSPSubscriptionActions[];
  newSubscriptionItems: AnnuityItemsViewModel[] = [];
  newOrderItems: CSPModifySubscriptionViewModel[] = [];
  itemsForUpdate: CSPModifySubscriptionViewModel[] = [];
  updatedItems: CSPModifySubscriptionResponse[] = [];

  pendingTotal: number = 0;
  activeTotal: number = 0;
  varianceAmount: number = 0;
  activeItems: GetCSPSubscription[];

  cancelledStatus: string[] = ["CT", "SC", "PC"];
  invalidTenant = false;
  paymentMethod: CustomerPaymentsOutput = null;
  digitalWalletId: string = "";
  //unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  //params
  programType: string;
  programName: string;
  tenantId: string;

  @ViewChild(BreadcrumbComponent) sample: BreadcrumbComponent;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private manageService: ManageService,
    private dialogService: DialogService,
    private ngProgress: NgProgressService,
    private commonService: CommonService,
    private checkOutService: CheckOutService
  ) { }

  ngOnInit() {
    this.ngProgress.start();

    const subscriptionInfo$ = this.activatedRoute.parent.paramMap.pipe(
      switchMap((params: any) =>
        this.activatedRoute.paramMap.pipe(
          map((param: any) => {
            return {
              programType: params.get("programType"),
              programName: params.get("programName"),
              tenantId: param.get("tenantId"),
            };
          })
        )
      )
    );

    $("#levelOne").animate({ scrollLeft: 250 }, 400);

    subscriptionInfo$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((info: any) => {
      this.tenantId = info.tenantId;
      this.programType = info.programType;
      this.programName = info.programName;
      this.invalidTenant = false;
      this.confirmRequired = false;
      this.loadContent = true;
      this.newOrderItems = [];
      this.manageService.monitorProgramType(this.programType);
      this.isEndUserLoading = true;
      this.manageService
        .getADKDetails(this.tenantId, this.programType)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (value: ADKDetailsViewModel) => {
            this.isEndUserLoading = false;
            this.details = value;
            this.paymentMethod = null;
            this.userStatus = this.details.customer.out_status_desc;
            this.manageService.monitorADKDetailsChange(this.details);
            this.manageService.monitorCurrentPaymentDetails({
              purchaseAccess: value.puchaseAccess,
              digitalWalletId: value.customer.out_digital_wallet_id
            });
            if (value.customer.out_digital_wallet_id) {
              this.digitalWalletId = value.customer.out_digital_wallet_id;
              this.checkOutService
                .GetSubscriptionPaymentMethodList()
                .subscribe((res) => {
                  if (res) {
                    this.paymentMethod = res.find(
                      (m) =>
                        m.out_customer_number ===
                        this.details.customer.out_digital_wallet_id
                    );
                    this.ngProgress.done();
                  }
                });
            }
            if (
              value.customer.out_status_desc === "Cancelled Tenant" ||
              value.customer.out_status_desc.includes("PENDING")
            ) {
              this.showCancelContract = false;
            }

            if (value.puchaseAccess === "Y") this.hasPurchaseAccess = true;

            if (
              this.cancelledStatus.indexOf(value.customer.out_status) > -1 ||
              value.customer.out_status_desc === "Cancelled Tenant"
            )
              this.invalidTenant = true;
              this.isSubscriptionLoading = true;
            this.getADKItemsView();

            if (this.programType === "ADM") {
              this.manageService.currentADKPendingSubscriptions.subscribe(
                (res: CSPModifySubscriptionViewModel[]) => {
                  if (res && res.length > 0) {
                    res.forEach((result) => {
                      this.newOrderItems.push(result);
                    });
                  }
                  // if (this.newOrderItems.length !== 0) {
                  //   this.setDisabled = false;
                  // }
                  this.calculatePendingTotal();
                  this.ngProgress.done();
                }
              );
            }

            if (this.programType === "ADY") {
              this.manageService.currentADKADYPendingSubscriptions.subscribe(
                (res: CSPModifySubscriptionViewModel[]) => {
                  if (res && res.length > 0) {
                    res.forEach((result) => {
                      this.newOrderItems.push(result);
                    });
                  }
                  // if (this.newOrderItems.length !== 0) {
                  //   this.setDisabled = false;
                  // }
                  this.calculatePendingTotal();
                  this.ngProgress.done();
                }
              );
            }
            //$('.page-contents').animate({ scrollLeft: $('#levelOne').width() + $("#managesubscriptionorders").width() }, 400);
          },
          (error: any) => {
            this.isEndUserLoading = false;
            console.info(error);
            this.ngProgress.done();
          }
        );

      this.manageService.getOrRefreshSubscriptionOrderSubject.asObservable()
      .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(() => {

          this.manageService
            .getADKDetails(this.tenantId, this.programType)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((value: ADKDetailsViewModel) => {
              this.paymentMethod = null;
              if (value.customer.out_digital_wallet_id) {
                this.digitalWalletId = value.customer.out_digital_wallet_id;
                this.checkOutService
                  .GetSubscriptionPaymentMethodList()
                  .subscribe((res) => {
                    if (res) {
                      this.paymentMethod = res.find(
                        (m) =>
                          m.out_customer_number ===
                          value.customer.out_digital_wallet_id
                      );
                    }
                  });
              }
              //this.manageService.monitorADKDetailsChange(value);
            });

        });
    });

    // this.activatedRoute.paramMap
    //   .takeUntil(this.ngUnsubscribe)
    //   .subscribe((param) => {
    //     this.tenantId = param.get("tenantId");
    //     $("#levelOne").animate({ scrollLeft: 250 }, 400);

    //     this.activatedRoute.parent.paramMap
    //       .takeUntil(this.ngUnsubscribe)
    //       .subscribe((value) => {
    //         this.programType = value.get("programType");
    //         this.programName = value.get("programName");

    //         this.newOrderItems = [];

    //         this.manageService.monitorProgramType(this.programType);

    //         this.manageService
    //           .getADKDetails(this.tenantId, this.programType)
    //           .takeUntil(this.ngUnsubscribe)
    //           .subscribe(
    //             (value: ADKDetailsViewModel) => {
    //               this.details = value;
    //               this.paymentMethod = null;
    //               this.userStatus = this.details.customer.out_status_desc;
    //               this.manageService.monitorADKDetailsChange(this.details);
    //               if (value.customer.out_digital_wallet_id) {
    //                 this.digitalWalletId = value.customer.out_digital_wallet_id;
    //                 this.checkOutService
    //                   .GetSubscriptionPaymentMethodList()
    //                   .subscribe((res) => {
    //                     if (res) {
    //                       this.paymentMethod = res.find(
    //                         (m) =>
    //                           m.out_customer_number ===
    //                           this.details.customer.out_digital_wallet_id
    //                       );
    //                     }
    //                   });
    //               }
    //               if (
    //                 value.customer.out_status_desc === "Cancelled Tenant" ||
    //                 value.customer.out_status_desc.includes("PENDING")
    //               ) {
    //                 this.showCancelContract = false;
    //               }

    //               if (value.puchaseAccess === "Y")
    //                 this.hasPurchaseAccess = true;

    //               if (
    //                 this.cancelledStatus.indexOf(value.customer.out_status) >
    //                   -1 ||
    //                 value.customer.out_status_desc === "Cancelled Tenant"
    //               )
    //                 this.invalidTenant = true;

    //               this.getADKItemsView();

    //               if (this.programType === "ADM") {
    //                 this.manageService.currentADKPendingSubscriptions.subscribe(
    //                   (res: CSPModifySubscriptionViewModel[]) => {
    //                     if (res && res.length > 0) {
    //                       res.forEach((result) => {
    //                         this.newOrderItems.push(result);
    //                       });
    //                     }
    //                     // if (this.newOrderItems.length !== 0) {
    //                     //   this.setDisabled = false;
    //                     // }
    //                     this.calculatePendingTotal();
    //                   }
    //                 );
    //               }

    //               if (this.programType === "ADY") {
    //                 this.manageService.currentADKADYPendingSubscriptions.subscribe(
    //                   (res: CSPModifySubscriptionViewModel[]) => {
    //                     if (res && res.length > 0) {
    //                       res.forEach((result) => {
    //                         this.newOrderItems.push(result);
    //                       });
    //                     }
    //                     // if (this.newOrderItems.length !== 0) {
    //                     //   this.setDisabled = false;
    //                     // }
    //                     this.calculatePendingTotal();
    //                   }
    //                 );
    //               }
    //               //$('.page-contents').animate({ scrollLeft: $('#levelOne').width() + $("#managesubscriptionorders").width() }, 400);
    //             },
    //             (error: any) => {
    //               console.info(error);
    //               this.ngProgress.done();
    //             }
    //           );

    //         this.manageService.currentBillingInfo
    //           .takeUntil(this.ngUnsubscribe)
    //           .subscribe((value) => {
    //             if (value === "ADK") {
    //               this.manageService
    //                 .getADKDetails(this.tenantId, this.programType)
    //                 .takeUntil(this.ngUnsubscribe)
    //                 .subscribe((value: ADKDetailsViewModel) => {
    //                   this.paymentMethod = null;
    //                   if (value.customer.out_digital_wallet_id) {
    //                     this.digitalWalletId =
    //                       value.customer.out_digital_wallet_id;
    //                     this.checkOutService
    //                       .GetSubscriptionPaymentMethodList()
    //                       .subscribe((res) => {
    //                         if (res) {
    //                           this.paymentMethod = res.find(
    //                             (m) =>
    //                               m.out_customer_number ===
    //                               this.details.customer.out_digital_wallet_id
    //                           );
    //                         }
    //                       });
    //                   }
    //                   this.manageService.monitorADKDetailsChange(value);
    //                 });
    //             }
    //           });
    //       });

    //     this.ngProgress.done();
    //   });
  }

  getADKItemsView() {
    this.manageService
      .getADKItemsView(this.tenantId, this.programType)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (value: ADKDetailsItemViewModel) => {
          this.adkItems = value;
          if (this.adkItems) {
            this.subscriptions = this.adkItems.subscriptions;
            this.actions = this.adkItems.actions;
            this.sortedSubscriptions = this.adkItems.subscriptions;
            //calculate total amount for each item
            this.sortedSubscriptions.forEach(
              (i) => (i.out_amount = this.getTotalPrice(i.out_price, i.out_qty))
            );
            //if tenant status is CT or SC or PC- the contract is cancelled so no more operations can be performed for this tenant
            if (this.invalidTenant)
              this.sortedSubscriptions.forEach(
                (x) => (x.out_status_desc = "Cancelled")
              );

            if (this.actions.length) {
              this.sortedSubscriptions.forEach((x) => {
                x.originalQty = x.out_qty;
                x.actions = this.actions.filter(
                  (i) => i.out_subscription_id === x.out_subscription_id
                );

                if (x.actions.length) {
                  x.actions.forEach((a) => {
                    switch (a.out_key) {
                      case "CREATE":
                        x.pendingChangeText = "Pending Order Creation";
                        break;
                      case "QTY":
                        x.pendingChangeText =
                          "Pending Qty Change to " + a.out_value;
                        break;
                      case "REF":
                        x.pendingChangeText =
                          "Pending Reference Change to " + a.out_value;
                        break;
                      case "REMOVE":
                        x.removeSubscription = true;
                        break;
                    }

                    if (a.out_status === "ER") {
                      x.pendingChangeText +=
                        " **Error** - " + a.out_error_message;
                      x.hasPendingError = true;
                    }
                  });
                }

                if (x.removeSubscription) {
                  x.out_status = "XX";
                  x.pendingChangeText = "Pending Remove Product";
                }
              });
            }

            this.activeItems = this.subscriptions.filter(
              (x) => x.out_status_desc.indexOf("Active") !== -1
            );
            if (this.activeItems) {
              for (let item of this.activeItems) {
                this.activeTotal =
                  this.activeTotal + parseFloat(item.out_amount);
              }
            }
          }
          this.isSubscriptionLoading = false;
          this.commonService.applyScrollFixedHeader(this.parentWrapper);
        },
        (error: any) => {
          console.info(error);
          this.isSubscriptionLoading = false;
          this.ngProgress.done();
        }
      );
  }

  collapsePanel(): void {
    this.ariaExpanded = !this.ariaExpanded;

    // if(this.ariaExpanded == true) {
    //    $('.subtitle').hide('slow');
    // } else {
    //   $('.subtitle').show('slow');
    // }
  }

  sortByStatus(status): void {
    this.currentStatus = status;

    if (this.subscriptions.length > 0) {
      this.sortedSubscriptions = this.subscriptions.filter(
        (x) => x.out_status_desc.indexOf(status) !== -1
      );
    }
  }

  getSubscriptionOrderList(): void {
    this.searchOrder = "";

    if (this.newSubscriptionItems.length === 0) {
      this.ngProgress.start();
      this.finishLoading = false;
      this.manageService
        .getADKItems(this.tenantId, this.programType)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (value: AnnuityItemsViewModel[]) => {
            this.newSubscriptionItems = value;
            this.finishLoading = true;
            this.ngProgress.done();
            $("#addNewSubscriptionModdal").appendTo("body").modal("show");
          },
          (error: any) => {
            console.info(error);
            this.ngProgress.done();
          }
        );
    } else {
      $("#addNewSubscriptionModdal").appendTo("body").modal("show");
    }
  }
  addAdkSubscription(): void {
    this.router.navigate(["AddADKSubscription"], {
      relativeTo: this.activatedRoute,
    });
  }

  editPaymentDetails(event): void {
    event.preventDefault();
    // this.manageService.monitorKaspDetailsChange(this.details);
    this.router.navigate(["EditPaymentDetails"], {
      relativeTo: this.activatedRoute,
    });
  }
  addNewOrders(item: AnnuityItemsViewModel, quantity: string): void {
    let newSubscription = {} as CSPModifySubscriptionViewModel;

    newSubscription.qty = quantity;
    newSubscription.stockCode = item.stockCode;
    newSubscription.stockDescription = item.description;
    newSubscription.tenantId = this.tenantId;
    newSubscription.status = "Pending Confirm";
    newSubscription.price = item.itemPrice;
    newSubscription.billingFrequency = item.billingFrequencyDesc;
    newSubscription.totalPrice = this.getTotalPrice(item.itemPrice, quantity);

    if (
      !this.newOrderItems.some((x) => x.stockCode == newSubscription.stockCode)
    ) {
      this.newOrderItems.push(newSubscription);
    } else {
      let index = this.newOrderItems.findIndex(
        (i) => i.stockCode == newSubscription.stockCode
      );

      let currentQty = parseInt(this.newOrderItems[index].qty);
      this.newOrderItems[index].qty = (
        parseInt(quantity) + currentQty
      ).toString();
      this.newOrderItems[index].totalPrice = (
        parseInt(this.newOrderItems[index].qty) *
        parseFloat(
          this.newOrderItems[index].price.replace("$", "").replace(/,/g, "")
        )
      ).toString();
    }

    this.calculatePendingTotal();

    this.setDisabled = false;
  }

  getTotalPrice(price: string, quantity: string): string {
    if (quantity !== "" && quantity !== "0")
      return (
        parseFloat(price.replace("$", "").replace(/,/g, "")) *
        parseInt(quantity)
      ).toString();

    return "0";
  }

  onQtyChange(
    stockCode: string,
    price: string,
    type: string,
    event: any
  ): void {
    const element = event.target as HTMLInputElement
    let qty = element.value
    if (qty == null || qty == "") qty = "1";

    if (type == "existing") {
      let index = this.sortedSubscriptions.findIndex(
        (x) => x.out_stock_code === stockCode
      );
      this.sortedSubscriptions[index].out_qty = qty;
      this.sortedSubscriptions[index].out_status_desc = "Pending Confirm";
      this.sortedSubscriptions[index].out_amount = (
        parseFloat(price) * parseInt(qty)
      ).toString();

      if (this.sortedSubscriptions[index].originalQty !== qty) {
        this.sortedSubscriptions[index].itemChanged = true;
      } else {
        this.sortedSubscriptions[index].itemChanged = false;
      }

      //add current existing items to newOrderItems array for update
      let updateSubscription = {} as CSPModifySubscriptionViewModel;

      updateSubscription.qty = qty;
      updateSubscription.stockCode = stockCode;
      updateSubscription.stockDescription = this.sortedSubscriptions[
        index
      ].out_stk_description;
      updateSubscription.subscriptionId = this.sortedSubscriptions[
        index
      ].out_subscription_id;
      updateSubscription.tenantId = this.tenantId;
      updateSubscription.status = "";

      if (
        !this.itemsForUpdate.some(
          (x) => x.stockCode == updateSubscription.stockCode
        )
      ) {
        this.itemsForUpdate.push(updateSubscription);
      } else {
        let index = this.itemsForUpdate.findIndex(
          (i) => i.stockCode == updateSubscription.stockCode
        );

        this.itemsForUpdate[index].qty = qty;
      }
    } else {
      let i = this.newOrderItems.findIndex((i) => i.stockCode === stockCode);
      this.newOrderItems[i].totalPrice = (
        parseFloat(price.replace("$", "").replace(/,/g, "")) * parseInt(qty)
      ).toString();
    }

    this.calculatePendingTotal();

    this.setDisabled = false;
  }

  removeOrder(stockCode: string): void {
    let idx = this.newOrderItems.findIndex((x) => x.stockCode === stockCode);

    this.newOrderItems.splice(idx, 1);

    this.calculatePendingTotal();

    if (this.newOrderItems.length == 0 && this.confirmRequired)
      this.setDisabled = true;
  }

  calculatePendingTotal(): void {
    let total = 0;
    let count = 0;

    this.sortedSubscriptions
      .filter((s) => s.out_status === "B" || s.out_status === "")
      .forEach((s) => {
        total += parseFloat(s.out_amount);

        if (s.itemChanged) count++;
      });

    this.newOrderItems.forEach((i) => (total += parseFloat(i.totalPrice)));
    this.pendingTotal = total;

    if (
      count === 0 &&
      this.newOrderItems.length === 0 &&
      this.itemsForUpdate.length === 0
    ) {
      this.pendingTotal = 0;
      this.confirmRequired = false;
    } else {
      this.confirmRequired = true;
    }

    if (this.pendingTotal < 0) {
      this.varianceAmount = this.pendingTotal;
    } else {
      this.varianceAmount = this.pendingTotal - this.activeTotal;
    }
  }

  confirmChanges(): void {
    let isValid = true;
    let commonService = this.commonService;
    $(".sub-ref").each(function () {
      if ($(this).val() == null || $(this).val() == "") {
        commonService.implementToast("Please enter your reference", "Error");
        isValid = false;
      }
    });

    $(".order-qty").each(function () {
      if ($(this).val() == null || $(this).val() == "") {
        commonService.implementToast("Please enter quantity", "Error");
        isValid = false;
      } else if (parseInt($(this).val()) < 1) {
        commonService.implementToast("Invalid quantity", "Error");
        isValid = false;
      }
    });

    if (isValid) {
      $("#confirmPendingModal").appendTo("body").modal("show");
    }
  }

  increaseDecreaseQty(item: GetCSPSubscription, type: string): void {
    let qty = parseInt(item.out_qty);

    if (qty > 0) {
      if (type === "increase") {
        qty++;
      } else {
        qty--;
      }

      const strQty = qty.toString();
      this.onQtyChange(item.out_stock_code, item.out_price, "existing", strQty);
    }
  }

  toggleActive(event: any, item: GetCSPSubscription): void {
    if (!event.checked) {
      this.deleteCurrentItem(item);
    } else {
      this.undoRemove(item.out_subscription_id, item.originalStatus);
    }
  }

  deleteCurrentItem(item: GetCSPSubscription): void {
    let deleteSubscription = {} as CSPModifySubscriptionViewModel;

    deleteSubscription.qty = item.out_qty;
    deleteSubscription.stockCode = item.out_stock_code;
    deleteSubscription.subscriptionId = item.out_subscription_id;
    deleteSubscription.stockDescription = item.out_stk_description;
    deleteSubscription.subscriptionId = item.out_subscription_id;
    deleteSubscription.tenantId = this.tenantId;
    deleteSubscription.totalPrice = item.out_amount;
    deleteSubscription.status = "RS";

    if (
      !this.itemsForUpdate.some(
        (x) => x.subscriptionId == deleteSubscription.subscriptionId
      )
    ) {
      this.itemsForUpdate.push(deleteSubscription);
    } else {
      let index = this.itemsForUpdate.findIndex(
        (i) => i.subscriptionId == deleteSubscription.subscriptionId
      );

      this.itemsForUpdate[index].status = "RS";
    }

    let idx = this.sortedSubscriptions.findIndex(
      (x) => x.out_subscription_id === item.out_subscription_id
    );
    //store original status for undo remove
    this.sortedSubscriptions[idx].originalStatus = item.out_status_desc;

    //update current array
    this.sortedSubscriptions[idx].out_status_desc = "Pending Confirm";
    this.sortedSubscriptions[idx].out_status = "RS";

    this.confirmRequired = true;
    this.setDisabled = false;

    this.calculatePendingTotal();
  }

  undoRemove(subscriptionId: string, originalStatus: string): void {
    let index = this.itemsForUpdate.findIndex(
      (i) => i.subscriptionId == subscriptionId
    );
    this.itemsForUpdate.splice(index, 1);

    let i = this.sortedSubscriptions.findIndex(
      (x) => x.out_subscription_id === subscriptionId
    );

    this.sortedSubscriptions[i].out_status_desc = originalStatus;
    this.sortedSubscriptions[i].out_status = "";

    if (!this.itemsForUpdate.length && !this.newOrderItems.length) {
      this.confirmRequired = false;
      this.setDisabled = true;
    }

    this.calculatePendingTotal();
  }

  confirmPendingTotal(): void {
    $("#confirmPendingModal").appendTo("body").modal("hide");
    this.ngProgress.start();
    let arrayForUpdate = this.itemsForUpdate.concat(this.newOrderItems);

    this.manageService.createOrUpdateCSPSubscription(arrayForUpdate).subscribe(
      (values: CSPModifySubscriptionResponse[]) => {
        this.updatedItems = values;
        //initialize arrays after updated
        this.newOrderItems = [];
        this.itemsForUpdate = [];
        this.newSubscriptionItems = [];
        this.confirmRequired = false;
        this.setDisabled = true;

        this.getADKItemsView();

        this.ngProgress.done();
        $("#updatedModal").appendTo("body").modal("show");
      },
      (error: any) => {
        console.info(error);
        this.ngProgress.done();
      }
    );
  }

  cleanPending(): void {
    this.newOrderItems = [];
    if (this.programType === "ADM") {
      this.manageService.monitorADKPendingSubscriptions(this.newOrderItems);
    }
    if (this.programType === "ADY") {
      this.manageService.monitorADKADYPendingSubscriptions(this.newOrderItems);
    }
  }

  cancelContract(): void {
    this.ngProgress.start();

    this.manageService
      .cancelContract(this.tenantId, this.programType)
      .subscribe(
        (val: any) => {
          if (val.status === true) {
            // $('#btnCancelContract').showValidator('Cancellation request submitted successfully', 'success', 'right');
            this.commonService.implementToast(
              "Cancellation request submitted successfully",
              "Success"
            );
            setTimeout(() => {
              this.close();
            }, 3000);
          } else {
            // $('#btnCancelContract').showValidator('Cancel request for tenantId - ' + this.tenantId + ' is unsuccessfull', 'fail', 'right');
            this.commonService.implementToast(
              "Cancel request for tenantId - " +
              this.tenantId +
              " is unsuccessfull",
              "Error"
            );
          }

          this.ngProgress.done();
        },
        (error: any) => {
          console.info(error);
          this.ngProgress.done();
        }
      );
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (!this.confirmRequired) {
      return true;
    }

    this.discardChanges$ = this.dialogService.confirm("Discard changes?");

    return this.discardChanges$;
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  close() {
    this.router.navigateByUrl(
      "/manageSubscriptions/manageAnnuities/" + this.programType
    );
    $("#levelOne").animate({ scrollLeft: 0 }, 400);
  }
}
